// @flow

import type { State } from "@store/reducers";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";

export const getHierarchyTree = (state: State): ?HierarchyTree =>
  (state.shared.hierarchy.active || {}).structure;

export const getMyHierarchyTree = (state: State): ?HierarchyTree =>
  (state.shared.hierarchy.myActive || {}).structure;
